export default {
    mapGeofenceVisibleTags_success: "Preferencias guardadas exitosamente",
    mapGeofenceVisibleTags_selectAll: "Seleccionar todo",
    mapGeofenceVisibleTags_unselectAll: "Des-seleccionar todo",
};